import React from 'react'
import Skeleton from 'react-loading-skeleton'
import { v4 as uuidv4 } from 'uuid'

import useStyles from './styles'

function ChangeHistorySkeleton() {
  const classes = useStyles()

  return (
    <>
      {Array.from({ length: 3 }).map(() => (
        <div key={uuidv4()}>
          <p>
            <Skeleton width={120} />
          </p>
          <p className={classes.details}>
            <Skeleton width="80%" />
          </p>
        </div>
      ))}
    </>
  )
}

export default ChangeHistorySkeleton
